import jQuery from "vendor/jquery";
import $ from "vendor/jquery";
import _ from "vendor/lodash";
import Handlebars from "vendor/handlebars";
import hbs from "vendor/handlebars";
export default class Templates {
    compile(templateString) {
        return Handlebars.compile(templateString);
    };
};